import Icon from '../components/Icon.vue'

Icon.register({
  'baby-carriage': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M144.8 17l111.2 175h-256c0-74 35.3-140.1 90.8-184.4 16.8-13.4 42.7-8.4 54 9.4zM496 96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v64c0 50.6-23 96.4-60.3 130.7 34.6 8.9 60.3 40 60.3 77.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-8.9 1.7-17.2 4.4-25.2-21.5 5.9-44.6 9.2-68.4 9.2s-46.8-3.3-68.4-9.2c2.6 8 4.4 16.3 4.4 25.2 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-37.3 25.7-68.4 60.3-77.3-37.3-34.3-60.3-80.1-60.3-130.7h384v-64c0-35.3 28.7-64 64-64h48zM80 464c17.6 0 32-14.4 32-32s-14.4-32-32-32-32 14.4-32 32 14.4 32 32 32zM400 432c0-17.6-14.4-32-32-32s-32 14.4-32 32 14.4 32 32 32 32-14.4 32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/baby-carriage.js
// module id = 634
// module chunks = 0